/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HealthcareServiceLocationModel } from '../../models/healthcare-service-location-model';

export interface AdminFhirIdLocationLocationFhirIdGet$Params {
  fhirId: string;
  locationFhirId: string;
}

export function adminFhirIdLocationLocationFhirIdGet(http: HttpClient, rootUrl: string, params: AdminFhirIdLocationLocationFhirIdGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<HealthcareServiceLocationModel>> {
  const rb = new RequestBuilder(rootUrl, adminFhirIdLocationLocationFhirIdGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
    rb.path('locationFhirId', params.locationFhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<HealthcareServiceLocationModel>;
    })
  );
}

adminFhirIdLocationLocationFhirIdGet.PATH = '/Admin/{fhirId}/Location/{locationFhirId}';
